import React from 'react';
import bowser from 'bowser';
import _ from 'lodash';

import ThemeSelector from '../themes/theme-selector';
import { Message } from 'semantic-ui-react';

const isFullWhiteLabel = ThemeSelector.isFullWhiteLabel();
const PLATFORM_NAME = isFullWhiteLabel ? 'our website' : 'dyzio';

const BrowserHandler = module.exports;

const isDyzio = _.eq(_.get(window, 'origin'), 'https://app.dyzio.co');


const chromeDownloadLink = () => (
  <a target="_blank" href="https://www.google.co.uk/chrome/browser/desktop/index.html">chrome</a>
);


const SafariMessage = () => {
  if (isDyzio) return null;
  return (
    <Message
      warning
      icon="frown"
      content={<span>Sorry - you cannot log in to the system using Safari at the minute... please try using {chromeDownloadLink()} instead.</span>}
    />
  );
};

BrowserHandler.safariHandle = {
  default: () => {
    if (bowser.safari) {
      return <SafariMessage />;
    }
    return <div />;
  },
};
BrowserHandler.handle = {
  chrome: () => <p>Chrome is the best browser to use for {PLATFORM_NAME}. Bravo!</p>,
  ie: () => doNotUseIE(),
  opera: () => shouldBeFine('Opera'),
  edge: () => shouldBeFine('Edge'),
  default: browser => {
    if (bowser.safari) {
      return <div />;
    }
    return weRecommendChrome();
  },
};


const weRecommendChrome = () => (
  <p>We recommend using {chromeDownloadLink()} with {PLATFORM_NAME}. It&apos;s fast, secure and free!</p>
);

const upgradeSafari = () => (
  <div className="browser-warning">
    <p>Hi, it looks like you are using an old version of Safari.</p>
    <p>Unfortunately {PLATFORM_NAME} will not work well in this browser.</p>
    <p>You should use Google {chromeDownloadLink()} or <a target="_blank" href="https://support.apple.com/en-gb/HT204416">upgrade Safari</a>.</p>
  </div>
);

const doNotUseIE = () => (
  <div className="browser-warning">
    <p>Hi, it looks like you are using Internet Explorer.</p>
    <p>Unfortunately {PLATFORM_NAME} will not work well in this browser.</p>
    <p>We recommend using {chromeDownloadLink()}. It&apos;s fast, secure and free!</p>
  </div>
);

const shouldBeFine = browser => (<p>{PLATFORM_NAME} should work fine in {browser}, but we recommend using {chromeDownloadLink()}.</p>);



/** WEBPACK FOOTER **
 ** ./src/utils/browser-handler.js
 **/